import type {TemplateNode} from "#template/template-node/template-node"
import {TemplateListNode} from "#template/template-list-node/template-list-node"
import {templateReferenceContainerMarker, type TemplateReferenceContainer} from "#template/role-markers"

export abstract class LikesListNode<out ItemType extends TemplateNode> extends TemplateListNode<ItemType> implements TemplateReferenceContainer {
    get [templateReferenceContainerMarker]() {
        return true as const
    }
}
